import { useEffect } from 'react';

type customAttrType = {
  attribute: string;
  value: string;
};

export const useScript = (
  url: string,
  id?: string,
  customAttributes?: Array<customAttrType>,
  addInBody?: boolean
) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = url;
    script.id = id;
    for (const [, item] of customAttributes.entries()) {
      script.setAttribute(item.attribute, item.value);
    }
    addInBody
      ? document.body.appendChild(script)
      : document.head.appendChild(script);

    return () => {
      addInBody
        ? document.body.removeChild(script)
        : document.head.removeChild(script);
    };
  }, []);
};

export default useScript;
